import { gql } from "@apollo/client";

export const RULES = gql`
  query Rules($where: RuleWhereInput, $skip: Int, $take: Int) {
    rules(where: $where, skip: $skip, take: $take) {
      data {
        name
        action
        configuration
      }
      count
    }
  }
`;

const rule = { RULES };

export default rule;
